<template>
  <div class="d-flex flex-column px-5 py-3">
    <div class="d-flex justify-space-between">
      <v-btn icon @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="mt-5 px-2">
      <div class="date-content">
        <div class="day">{{ formattedDay }}</div>
        <div class="date">{{ formattedDate }}</div>
        <div class="month">{{ formattedMonth }}</div>
      </div>

      <v-list>
        <v-list-item-group>
          <v-list-item v-show="birthdayEvents.length != 0">
            <v-list-item-content>
              <v-card-title>
                <div style="display: flex; align-items: center">
                  <v-icon style="font-size: 20px; margin: 1px 5px"
                    >mdi-cake</v-icon
                  >
                  Birthday
                </div>
              </v-card-title>
              <v-divider />
              <div class="row-container">
                <div
                  v-for="(bday, index) in birthdayEvents"
                  :key="index"
                  class="row-item"
                >
                  <v-card>
                    <v-card-title>{{ bday.data.fullName }}</v-card-title>
                    <v-card-subtitle>{{
                      bday.data.contactTypeName
                    }}</v-card-subtitle>
                  </v-card>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-ripple="false">
            <v-list-item-content>
              <v-card-title>
                <div style="display: flex; align-items: center">
                  <v-icon style="font-size: 20px; margin: 1px 5px"
                    >mdi-file-document</v-icon
                  >
                  Expiring Documents
                </div>
              </v-card-title>
              <v-divider />
              <div class="row-container">
                <div
                  v-if="expiringEvents.length == 0"
                  style="margin: 10px 25px; color: #999"
                >
                  No documents to show
                </div>
                <div
                  v-for="(exp, index) in expiringEvents"
                  :key="index"
                  class="row-item"
                >
                  <v-card>
                    <v-card-title @click.stop="viewUser(exp)">
                      {{
                        exp.studentName !== null
                          ? exp.studentName
                          : exp.staffName
                      }}
                    </v-card-title>
                    <v-card-subtitle> </v-card-subtitle>
                    <v-divider />
                    <v-card-subtitle
                      >{{ exp.requirements.length }} documents expired
                      <v-icon
                        style="font-size: 20px; margin: 1px 5px"
                        @click.stop="toggleRequirements(exp)"
                        >mdi-chevron-down</v-icon
                      ></v-card-subtitle
                    >
                    <v-card-subtitle v-if="exp.showRequirements">
                      <div
                        v-for="(requirement, index) in exp.requirements"
                        :key="index"
                      >
                        {{ requirement }}
                      </div>
                    </v-card-subtitle>
                  </v-card>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    isOpen: Boolean,
    eventData: {
      type: Array,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
  },

  watch: {
    startDate: "generateDaysArray",
    endDate: "generateDaysArray",
    eventData: {
      immediate: true,
      handler() {
        this.categorizeEvents();
      },
    },
  },

  computed: {
    formattedDay() {
      return moment(this.date).format("ddd");
    },
    formattedDate() {
      return moment(this.date).format("DD");
    },
    formattedMonth() {
      return moment(this.date).format("MMM");
    },
  },

  data() {
    return {
      birthdayEvents: [],
      expiringEvents: [],
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },

    toggleRequirements(exp) {
      this.$set(exp, "showRequirements", !exp.showRequirements);
    },

    categorizeEvents() {
      this.birthdayEvents = [];
      this.expiringEvents = [];
      const newEvent = [];
      this.eventData.forEach((event) => {
        const eventDate = moment(event.start).format("YYYY-MM-DD");
        if (
          event.type === "birthday" &&
          event.data.dob.substr(5, 9) == this.date.substr(5, 9)
        ) {
          this.birthdayEvents.push(event);
        } else if (event.type === "expiring" && eventDate == this.date) {
          // Check if there's an entry in newEvent with the same staff Id/student id and date
          const matchingEntry = newEvent.find(
            (entry) =>
              (((entry.staffId != null || entry.staffId != undefined) &&
                entry.staffId == event.data.staffId) ||
                (!event.data.staffId &&
                  entry.studentId == event.data.studentId)) &&
              entry.date == eventDate
          );

          // If there's a match, add the requirementName to the requirements array
          if (matchingEntry) {
            matchingEntry.requirements.push(event.data.requirementName);
          } else {
            // If no match, create a new entry in newEvent
            newEvent.push({
              staffId: event.data.staffId,
              studentId: event.data.studentId,
              staffName: event.data.staffName,
              studentName: event.data.studentName,
              certificateExpiresOn: event.data.certificateExpiresOn,
              date: eventDate,
              requirements: [event.data.requirementName],
            });
          }
        }
      });
      this.expiringEvents = newEvent.sort((a, b) => {
        const nameA = a.staffName || a.studentName || ""; 
        const nameB = b.staffName || b.studentName || ""; 

        return nameA.localeCompare(nameB);
      });
    },
  },
};
</script>

<style scoped>
.side-panel {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 300px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 16px;
}

.date-content {
  margin: 10px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  flex: 1;
}

.date-content .day {
  color: #999;
}

.date-content .date {
  color: #000;
  font-weight: bold;
  font-size: 30px;
}

.date-content .month {
  color: #000;
  font-size: 20px;
}

.v-list-container {
  flex: 1;
  margin-left: 16px;
}

.row-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
}

.row-item {
  width: 100%;
  margin: 5px;
  box-sizing: border-box;
}
</style>
